<video class="w-100" controls [poster]="thumbnail?.url">
    <source [src]="'/assets/videos/' + video" type="video/mp4" />
</video>
